import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=2e0ce68a&"
import script from "./ProfileUser.vue?vue&type=script&lang=js&"
export * from "./ProfileUser.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUser.vue?vue&type=style&index=0&id=2e0ce68a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports